import { render, staticRenderFns } from "./zreport_main.vue?vue&type=template&id=272ec2d0&scoped=true"
import script from "./zreport_main.vue?vue&type=script&lang=js"
export * from "./zreport_main.vue?vue&type=script&lang=js"
import style0 from "./zreport_main.vue?vue&type=style&index=0&id=272ec2d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272ec2d0",
  null
  
)

export default component.exports